// extracted by mini-css-extract-plugin
export default {"button_card_open_modal":"ButtonCardOpenModal-module__button_card_open_modal--UrgJC"};